import type { HTMLProps } from 'react';

import { Collapsible } from '@tripleten/design-system/collapsible';

import { IconTick } from 'src/shared/components/icon-tick/icon-tick.js';

import { cnCheckboxWrapper } from './kc-checkbox-wrapper.constants.js';
import { cnCheckbox } from './kc-checkbox.constants.js';

import './checkbox.css';

interface CheckboxProps {
    errorMessage?: string;
    childrenWrapperClassName?: string;
}

export const Checkbox = (props: HTMLProps<HTMLInputElement> & CheckboxProps) => {
    const {
        className,
        childrenWrapperClassName,
        onChange,
        checked,
        children,
        disabled,
        value,
        name,
        errorMessage,
        ...restProps
    } = props;
    const isError = Boolean(errorMessage);

    return (
        <div className={cnCheckboxWrapper()}>
            <label className={cnCheckbox({ disabled }, [className])}>
                <input
                    name={name}
                    checked={checked}
                    value={value}
                    className={cnCheckbox('input')}
                    disabled={disabled}
                    onChange={onChange}
                    type="checkbox"
                    {...restProps}
                />
                <div className={cnCheckbox('control')}>
                    <IconTick className={cnCheckbox('tick')} />
                </div>
                <div className={cnCheckbox('label', [childrenWrapperClassName])}>{children}</div>
            </label>
            <Collapsible open={isError}>
                <Collapsible.Panel>
                    {isError && <div className={cnCheckbox('message', { error: isError })}>{errorMessage}</div>}
                </Collapsible.Panel>
            </Collapsible>
        </div>
    );
};
